import { Link } from "react-router-dom";

export default function Sidebar({ user }) {
  if (!user) return null;

  // 🔥 SAFE ROLE CHECK
  const role = user.role?.toUpperCase().trim();

  return (
    <div
      className="sidebar d-flex flex-column p-3 bg-primary text-white"
      style={{ width: "240px", minHeight: "100vh" }}
    >
      <h5 className="mb-3">SMB GROUP</h5>

      {/* DASHBOARD */}
      <Link className="text-white mb-2 text-decoration-none" to="/">
        🏠 Dashboard
      </Link>

      {/* MEMBER */}
      <div className="mt-3 fw-bold">MEMBER</div>

      <Link
        className="text-white mb-2 text-decoration-none"
        to="/member-registration"
      >
        👤 Member Registration
      </Link>

      <Link
        className="text-white mb-2 text-decoration-none"
        to="/member-detail"
      >
        📋 Member Detail
      </Link>

      {/* OFFERS – ADMIN ONLY */}
      {role === "ADMIN" && (
        <Link
          className="text-white mb-2 text-decoration-none"
          to="/offers"
        >
          💰 Offers
        </Link>
      )}

      {/* SAVING */}
      <div className="mt-3 fw-bold">SAVING A/C</div>

      <Link
        className="text-white mb-2 text-decoration-none"
        to="/open-saving"
      >
        💼 Open Saving A/C
      </Link>

      <Link
        className="text-white mb-2 text-decoration-none"
        to="/saving-ledger"
      >
        📒 Saving Ledger
      </Link>

      {/* REPORTS */}
      <div className="mt-3 fw-bold">REPORTS</div>

      <Link
        className="text-white mb-2 text-decoration-none"
        to="/day-book"
      >
        📅 Day Book
      </Link>

      <Link
        className="text-white mb-2 text-decoration-none"
        to="/due-members"
      >
        ⏰ Due Members
      </Link>

      <Link
        className="text-white mb-2 text-decoration-none"
        to="/advance-members"
      >
        ⬆ Advance Members
      </Link>

      {/* ADMIN ONLY */}
      {role === "ADMIN" && (
        <>
          <div className="mt-3 fw-bold">ADMIN</div>

          <Link
            className="text-white mb-2 text-decoration-none"
            to="/create-staff"
          >
            ➕ Create Staff
          </Link>

          <Link
            className="text-white mb-2 text-decoration-none"
            to="/staff-list"
          >
            📃 Staff List
          </Link>

          <Link
            className="text-white mb-2 text-decoration-none"
            to="/fund-transfer"
          >
            🔁 Fund Transfer
          </Link>
        </>
      )}
    </div>
  );
}